import { render } from "./TplanEditor.vue?vue&type=template&id=3130dd4c"
import script from "./TplanEditor.vue?vue&type=script&lang=js"
export * from "./TplanEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__